import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MenuService} from '../../services/menu.service';
import {Subscription} from 'rxjs/Subscription';
import { combineLatest } from 'rxjs';
import {DOCUMENT} from '@angular/common';
import {
  CHECK_ACCOUNT_STATUS,
  CHECK_FALCON_PREPAID, CHECK_PEPI_CLIENT, CHECK_SUBUSER, CHECK_SUBUSER_LOGIN, CHECK_UNLIMITED_CODE_APPLIED, GET_PLAN_TYPE,
  WARMUPSLAB_DETAILS, GET_INSIGHTS_PAGE_ACESS, GET_HOME_DASHBOARD_DATA} from '../../../config';
import {ApiService} from '../../services/api.service';
import {AlertsService} from '../../services/alerts.service';
import {DataService} from '../../services/data.service';
import {AuthService} from "../../../services/auth.service";
import { Globals } from '../../services/globals';
import {CustomMenuIconService} from '../../../pages/services/custom-menu-icon.service';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { SubSink } from 'subsink';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-new-main-menu',
  templateUrl: './new-main-menu.component.html',
  styleUrls: ['./new-main-menu.component.scss']
})
export class NewMainMenuComponent implements OnInit, OnDestroy {
  showMenu = true;
  subMenuShow = false;
  analyticMenu = false;
  insightSubMenuShow = false;
  billingSubMenuShow = false;
  whatsappSubMenuShow = false;
  grcsManageReportSubMenuShow = false;

  preferred_accountStatus: any;
  whatsapp_enabled_sttaus: any;
  accountStatus: any;
  falconPrepaidSub: Subscription;
  menuSubscription: Subscription;
  refreshPageSub: Subscription;
  prefAccSub: Subscription;
  hideBillingMenu: boolean;
  hideCreditManagement: boolean;
  hideCreditManagement1 = false;
  falconide = false;
  type = '';
  msg = '';
  hideWarmup = true;
  hideBilling: boolean;
  hideSubUserMenu: boolean;
  hideSubUserMenu1: boolean;
  // falconPrepaid: boolean;
  falconPrepaid = true;
  hideOldBillingMenu = false;
  postpaidClient = false;
  subaccount: any;
  newMater: any;
  savings: any;

  showLatencyPage = false;
  showSpillOverPage = false;
  showEngagementPage = false;
  showDeliverabilityPage = false;  // google postmaster
  showInboxablePage = false;
  showHealthScorePage = false;

  pepi_enterprise: any;
  us_enterprise : boolean;    // whether login client is a US Enterprise customer or not
  new_reporting : boolean;    // variable decide wether new reporting allowed or not
  wa_billing: boolean = false;
  // hasSecondaryMenu: false;
  alertSubscription: Subscription;
  alertText = '';
  alertTextP1: any;
  activePath :string ='';
  accessMgmtMode = false;
  currentYear = new Date().getFullYear();

  /* home dashboard variables */
  settingData: any;
  clientid : any;
  grcsSubMenuShow: boolean = false;
  whatsappSettingSubMenuShow: boolean;
  grcsShowReportsSubMenu: boolean;
  shouldShowSMSReportsSubMenu: boolean = false;
  shouldShowBillingSubMenu: boolean = false;
  isDomesticClient: boolean = false;

  public showRCSSettingSubMenu: boolean = false;
  prepaidEnterprisePresent: boolean = false;
  private routerEventsSub: Subscription;

  private subs = new SubSink();

  constructor(private menuService: MenuService,
              private apiService: ApiService,
              private alertsService: AlertsService,
              private dataService: DataService,
              @Inject(DOCUMENT) private document: any,
              private sevicegurd: AuthService,
              private headerService: HeaderService,
              private CustomMenuIconService: CustomMenuIconService,
              private router: Router, public globals: Globals ) {
                // using service to register custom menu icon
                this.CustomMenuIconService.init();
                const initialUrl = this.router.url || '';
                this.activePath = this.stripUrl(initialUrl);
                this.updateAccessMgmtMode(initialUrl);
                this.routerEventsSub = this.router.events.subscribe((event: RouterEvent) => {
                  if (event instanceof NavigationEnd) {
                    const url = event.urlAfterRedirects || event.url || '';
                    this.activePath = this.stripUrl(url);
                    this.updateAccessMgmtMode(url);
                    this.dataService.activePath(this.activePath);
                  } else if ((event as any) && typeof (event as any).url === 'string') {
                    const url = (event as any).url;
                    this.activePath = this.stripUrl(url);
                    this.updateAccessMgmtMode(url);
                    this.dataService.activePath(this.activePath);
                  }
                });

              }

  ngOnInit() {

    this.getInsightsPageAccess( );

    // Subscribe to SMS Billing Overview access flag
    this.dataService.prepaidEnterprisePresent$.subscribe((flag: number | null) => {
      this.prepaidEnterprisePresent = Boolean(flag);
    });

    this.falconPrepaidSub = this.menuService.falconPrepaid$.subscribe(bool => {
      this.falconPrepaid = bool;

      this.checkFalconPrepaidClient();
    });

    this.menuSubscription = this.menuService.showMenu$.subscribe(bool => {
      this.showMenu = bool;
      // If something hides the menu while in Access Management mode, force it back on.
      if (!bool && this.accessMgmtMode) {
        this.menuService.showMenu();
      }
    });
    this.refreshPageSub = this.alertsService.refreshPage$.subscribe(bool => this.refreshMenu());
    this.prefAccSub = this.menuService.preferredAccountStatus$.subscribe(num => this.preferred_accountStatus = num);

    this.init();
    this.us_enterprise = false;
    this.new_reporting = false;
    this.activePath = this.stripUrl(this.router.url || '');
    // this.dataService.activePath(this.router.url);

     this.alertSubscription = this.alertsService.p0Alert$
      .subscribe(text => this.alertText = text);

    this.alertSubscription = this.alertsService.p1Alert$
      .subscribe(text => this.alertTextP1 = text);

  }

  ngAfterViewInit() {
    // One subscription: margin must reflect *either* header alerts or demo banner (not last-writer-wins).
    this.subs.sink = combineLatest([
      this.alertsService.alertPresent$,
      this.headerService.demoMode$,
    ]).subscribe(([alertPresent, demoMode]) => {
      this.setCssAlert(alertPresent === true || demoMode === true);
    });
  }
  init() {
    // this.checkRoleLevelAccess();
    this.checkSubuserLogin();
    this.getPlanType();
    this.checkPepipostClient();
    this.checkUnlimitedCodeApplied();
    this.fetchWarmUpDetails();
    this.checkSubuser();
    this.fetchWithoutActivatUserDetails();
  }

  checkSubuserLogin() {
    this.apiService.get(CHECK_SUBUSER_LOGIN).subscribe(
      result => {
        if (String(result['status']).toLowerCase() === 'success' && result['data'] != null) {
          const isSubuser = !!(result['data']['is_subuser'] || result['data']['subuser']);
          this.sevicegurd.setSubUserState(isSubuser);
        }
      }
    );
  }

  setCssAlert(data){
    if( (document.querySelector('.primary-menu') as HTMLElement) ){
      if(data === true){
        (document.querySelector('.primary-menu') as HTMLElement).style['margin-top'] = '120px';
      }else{
        (document.querySelector('.primary-menu') as HTMLElement).style['margin-top'] = '60px';
      }
    }
  }

  refreshMenu() {
    // this.init();
    // this.ngOnInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.menuSubscription.unsubscribe();
    this.falconPrepaidSub.unsubscribe();
    this.refreshPageSub.unsubscribe();
    this.prefAccSub.unsubscribe();
    if (this.routerEventsSub) {
      this.routerEventsSub.unsubscribe();
    }
  }

  private stripUrl(url: string): string {
    return (url || '').split('?')[0].split('#')[0];
  }

  private updateAccessMgmtMode(url: string) {
    const path = this.stripUrl(url);
    const qp = this.router.parseUrl(url || '').queryParams || {};
    // const flag = qp['accessMgmt'];
    // const isEnabled = flag === '1' || flag === 1 || flag === true || flag === 'true';
    // Support apps hosted under a base path like `/app/...`
    this.accessMgmtMode = Boolean(path.includes('/settings/manage-users-new') || path.includes('/settings/audit-logs'));
  }

  fetchWithoutActivatUserDetails() {
    this.dataService.accountStatus$.subscribe(message => {
        if (this.dataService.isEmpty(message)) {
          this.apiService.get(CHECK_ACCOUNT_STATUS).subscribe(result => {
            if (result['status'] === 'success')
              this.dataService.checkAccountStatus(result['data']);
            this.fetchWithoutActivatUserDetails();
          });
          return;
        }

        this.accountStatus = message['status'];
        this.preferred_accountStatus = message['pre_plan_status'];
        this.whatsapp_enabled_sttaus = message['wa_enable'];
    });
  }

  checkFalconPrepaidClient() {
    if (this.falconPrepaid) {
      this.hideBillingMenu = true;
      this.hideCreditManagement1 = true;
    } else {
      this.hideCreditManagement1 = false;
    }
  }

  getPlanType() {
    this.dataService.planType$.subscribe(message => {
        if (this.dataService.isEmpty(message)) {
          this.apiService.post(GET_PLAN_TYPE, '').subscribe(result => {
            if (String(result['status']).toLowerCase() === 'success')
              this.dataService.planType(result);
            this.getPlanType();
          });
          return;
        }

        if (String(message['status']).toLowerCase() === 'success') {
          this.pepi_enterprise = (message['data']['pepi_enterprise']);
          this.falconide = (+message['data']['martech_client'] !== 3) ? true : false;

          if( this.falconide ){  // if user is falconide / enterprise
            this.showHealthScorePage = true;
            this.showInboxablePage = true;
            this.showDeliverabilityPage = true;
            this.showLatencyPage = true;
          }

          if (message['data'] !== 'null') {

            this.savings = message['data']['savings'] === 1 ? true : false;

            if (message['data']['falconide_postpaid'] === 1) {
              //  this.hideBillingMenu = false;
              this.hideBillingMenu = true;
            }

            if (message['data']['new_pricing'] === 1) {
              this.hideOldBillingMenu = true;
            } else {
              this.hideOldBillingMenu = false;
            }

            if (message['data']['client_type'] === 'postpaid') {
              this.postpaidClient = true;
              this.hideCreditManagement = true;
            } else {
              this.hideCreditManagement = false;
            }
            this.isDomesticClient = message['data']['is_domestic'] === '1' ? true : false;
          }
        } else {
          this.type = 'danger';
          this.msg = message['error_info']['message'];
        }

    });
  }


  checkPepipostClient() {
    this.dataService.isPepiClient$.subscribe(message => {
        if (this.dataService.isEmpty(message)) {
          this.apiService.post(CHECK_PEPI_CLIENT, '').subscribe(result => {
            if (String(result['status']).toLowerCase() === 'success')
              this.dataService.checkPepiClient(result);
            this.checkPepipostClient();
          });
          return;
        }

        if (String(message['status']).toLowerCase() === 'success') {
          if (message['data'] !== 'null') {
            if (message['data']['martech_client'] === 'pepipost') {
              this.hideBillingMenu = true;
            }
          }
        } else {
          this.type = 'danger';
          this.msg = message['error_info']['message'];
        }

    });

    /*this.apiService.post(CHECK_PEPI_CLIENT, '')
      .subscribe(result => {
          if (String(result['status']).toLowerCase() === 'success') {
            if (result['data'] !== 'null') {
              if (result['data']['martech_client'] === 'pepipost') {
                this.hideBillingMenu = true;
              }
            }
          } else {
            this.type = 'danger';
            this.msg = result['error_info']['message'];
          }
        }
      );*/
  }

  checkUnlimitedCodeApplied() {
    this.dataService.isUnlimitedCodeApplied$.subscribe(message => {
        if (this.dataService.isEmpty(message)) {
          this.apiService.post(CHECK_UNLIMITED_CODE_APPLIED, '').subscribe(result => {
            if (String(result['status']).toLowerCase() === 'success')
              this.dataService.checkUnlimitedCodeApplied(result);
            this.checkUnlimitedCodeApplied();
          });
          return;
        }

        if (String(message['status']).toLowerCase() === 'success') {
          if (message['data']['unlimited_plan'] === 1) {
            // console.log('Unlimited code applied');
            this.hideCreditManagement = true;
          } else {
            this.hideCreditManagement = false;
          }
        } else {
          this.type = 'danger';
          this.msg = message['error_info']['message'];
        }

    });

    /*this.apiService.post(CHECK_UNLIMITED_CODE_APPLIED, '')
      .subscribe(result => {
          if (String(result['status']).toLowerCase() === 'success') {
            if (result['data']['unlimited_plan'] === 1) {
              // console.log('Unlimited code applied');
              this.hideCreditManagement = true;
            } else {
              this.hideCreditManagement = false;
            }
          } else {
            this.type = 'danger';
            this.msg = result['error_info']['message'];
          }
        }
      );*/
  }

  fetchWarmUpDetails() {
    this.dataService.warmupSlabDetails$.subscribe(message => {
        if (this.dataService.isEmpty(message)) {
          this.apiService.post(WARMUPSLAB_DETAILS).subscribe(result => {
            if (String(result['status']).toLowerCase() === 'success')
              this.dataService.warmupSlabDetails(result);
            this.fetchWarmUpDetails();
          });
          return;
        }

        if (message['status'] === 'success') {
          this.hideWarmup = Object.keys(message['data']['clientWarmupSlab']).length > 0 ? false : true;
        }

    });

    /*this.apiService.post(WARMUPSLAB_DETAILS)
      .subscribe((result) => {
          if (result['status'] === 'success') {
            this.hideWarmup = Object.keys(result['data']['clientWarmupSlab']).length > 0 ? false : true;
          }
        },
      );*/
  }

  checkSubuser() {
    console.log( " --- calling  checkSubuser- new menu --- " );
    this.apiService.post(CHECK_SUBUSER, '')
      .subscribe(result => {

          if (String(result['status']).toLowerCase() === 'success') {

            console.log( " checkSubuser result  ", result['data'] )
            this.dataService.checkSubuser( result ); // Store CHECK_SUBUSER API call result
            if (result['data']['sub_user'] > 0) {
              // this.subaccount = true;
              this.hideSubUserMenu1 = true;
              this.hideBillingMenu = true;
              this.hideCreditManagement = true;
              if (this.postpaidClient === true) {
                this.hideBillingMenu = false;
              }
            } else {
              // for parent account
              // this.subaccount = false;
              this.hideBilling = false;
              this.hideSubUserMenu1 = false;
              // this.hideCreditManagement1 = false;
              this.hideCreditManagement = false;
            }
            // Conditions for subaccount
            if (result['data']['subaccount']) {
              this.subaccount = true;
              this.sevicegurd.setMasterState('subaccount');
              sessionStorage.setItem('loginUserAccountType', 'subaccount');
            } else {
              this.sevicegurd.setMasterState('master');
              sessionStorage.setItem('loginUserAccountType', 'master');
              if (result['data']['subaccount_menu'] > 0) {
                this.newMater = true;
              } else {
                this.newMater = false;
              }
              this.subaccount = false;
            }
            // Check for the forever free plan
            if (result['data']['forever_free_plan'] > 0) {
              //add sub account flag dont dispaly sub account to free plan users
              // this.subaccount = true;
              this.hideSubUserMenu = true;
            } else {
              // this.subaccount = false;
              this.hideSubUserMenu = false;
            }

            if( result['data']['isUsClient'] === 1 ){
              this.us_enterprise = true;
            }

            if(+result['data']['rp'] === 1 ){
              this.new_reporting = true;
            }

            if(+result['data']['wa_billing'] === 1 ){
              this.wa_billing = true;
            }


            if( result['data']['freshUser'] && result['data']['freshUser'] === true ){   // if no mailing history found
              this.dataService.setFirstTimeExperience( true );
            }
            else if( result['data']['freshUser'] && result['data']['freshUser'] === false ){
              this.dataService.setFirstTimeExperience( false );
            }

            /*Added by Akshay J
              In App performance project CHECK_SUBUSER Api was also called in src/app/pages/services/menu service ts file so code patch of
              success response from menu service now putted here
            */
            if (result['data']['sub_user'] > 0 || result['data']['subaccount'] > 0 ) {

              this.menuService.setSubUserValue( true );

              if (result['data']['parent'] !== '' || result['data']['parent'] !== null) {
                this.menuService.setParentUserName( result['data']['parent'] );
              } else {
                this.menuService.setParentUserName( '' );
              }
            } else {
              this.menuService.setSubUserValue( false );
              this.menuService.setParentUserName( '' );
            }

          } else {
            this.type = 'danger';
            this.msg = result['error_info']['message'];
          }
        }
      );
  }

  getInsightsPageAccess( ){      // function to call insight page acess api

    this.apiService.get( GET_INSIGHTS_PAGE_ACESS )
      .subscribe((result) => {
        console.log( " check getInsightsPageAccess res -> ", result  );

        if (result['status'] === 'success') {

          let pageAccess = [];
          pageAccess = result.data;
          pageAccess['home_dashboard'] = false;

          if( ( parseInt( result.data['martech_client'] ) !== 3 ) || ( ( result.data['7'] && result.data['7'].status === "1" ) && ( result.data['4'] && result.data['4'].status === "1" ) )  ){  // if home dashboard allowed

            pageAccess['home_dashboard'] = true;

            // -- code to first time after login fetch setting
            this.apiService.get( GET_HOME_DASHBOARD_DATA ).subscribe( result => {
              console.log( "GET_HOME_DASHBOARD_DATA - result  ", result )
              if (result['status'] === 'success') {

                // delete old session storage of home dashbord
                console.log( " delete homesettings - from main menu  ")
                sessionStorage.removeItem( 'homeSettings_' + this.clientid );

                if (typeof result['data'] === 'string') {
                  this.settingData = JSON.parse( result['data'] );
                } else {
                  this.settingData = result['data'];
                }

                this.clientid = this.settingData['cid'];
                // add fresh home settings into ssession storage
                const now = new Date();
                const homeSettings = {
                  data: this.settingData,
                  expiry: now.getTime() + 7200000,  // expiry time of 2 hrs
                };
                sessionStorage.setItem(
                  'homeSettings_' + this.clientid ,
                  JSON.stringify(homeSettings)
                );
              }
            })

          }
          this.dataService.setPageLevelAccess( pageAccess );

          this.showEngagementPage = true;

          if ( result.data["3"] && result.data["3"].status === "1" ) {   // if spillover allowed
            this.showSpillOverPage = true;
          }

          if ( result.data["11"] && result.data["11"].status === "1" ) {   // if Healthscore allowed
            this.showHealthScorePage = true;
          }
          if( result.data["1"] && result.data["1"].status === "1" ){   // if deliverability allowed
            this.showDeliverabilityPage = true;
          }
          if ( result.data["6"] && result.data["6"].status === "1" ) {   // if inboxable allowed
            this.showInboxablePage = true;
          }
          if( result.data["2"] && result.data["2"].status === "1" ){   // if latency allowed
            this.showLatencyPage = true;
          }

          /*
          if( result.data["2"] && result.data["2"].status === "1" ){   // if latency allowed
            this.showLatencyPage = true;
          }
          if ( result.data["5"] && result.data["5"].status === "1" ) {   // if engagement allowed
            this.showEngagementPage = true;
          }
          if( result.data["1"] && result.data["1"].status === "1" ){   // if deliverability allowed
            this.showDeliverabilityPage = true;
          }
          if ( result.data["6"] && result.data["6"].status === "1" ) {   // if inboxable allowed
            this.showInboxablePage = true;
          }
          if ( result.data["11"] && result.data["11"].status === "1" ) {   // if Healthscore allowed
            this.showHealthScorePage = true;
          }
          */

        }
      });
  }

  showSubMenu() {
    this.subMenuShow = !this.subMenuShow;
    this.billingSubMenuShow  = false;
    this.analyticMenu = false;
    this.insightSubMenuShow = false;
  }
  analyticsShowSubMenu() {
    this.analyticMenu = !this.analyticMenu;
    this.billingSubMenuShow  = false;
    this.subMenuShow = false;
    this.insightSubMenuShow = false;
  }
  insightShowSubMenu() {
    this.insightSubMenuShow  = !this.insightSubMenuShow;
    this.billingSubMenuShow  = false;
    this.subMenuShow = false;
    this.analyticMenu = false;
  }
  billingShowSubMenu() {
    this.billingSubMenuShow = !this.billingSubMenuShow;
    this.insightSubMenuShow  = false;
    this.subMenuShow = false;
    this.analyticMenu = false;
  }
  whatsappShowSubMenu() {
    this.whatsappSubMenuShow = !this.whatsappSubMenuShow;
    this.whatsappSettingSubMenuShow = false;
  }

  whatsappSettingsShowMenu() {
    this.whatsappSettingSubMenuShow = !this.whatsappSettingSubMenuShow;
    this.whatsappSubMenuShow = false;
  }

  rcsSettingsShowMenu() {
    this.showRCSSettingSubMenu = !this.showRCSSettingSubMenu;
  }

  grcsShowSubMenu() {
    this.grcsSubMenuShow = !this.grcsSubMenuShow;
  }

  grcsShowReportSubMenu() {
    this.grcsShowReportsSubMenu = !this.grcsShowReportsSubMenu;
  }

  toggleSMSSReportSubMenu() {
    this.shouldShowSMSReportsSubMenu = !this.shouldShowSMSReportsSubMenu;
  }
}
